// extracted by mini-css-extract-plugin
export default {"wrapper":"ingredient-item_wrapper__A3ZWG","price":"ingredient-item_price__MfHm8","box":"ingredient-item_box__av5zF","img_item":"ingredient-item_img_item__O+ESb"};